type CountriesBody = {
  id?: number;
  is_active?: boolean;
  order_by?: "asc" | "desc";
};

export async function getCountries(body: CountriesBody = {}) {
  const apiBase = import.meta.env.VITE_APP_ENDPOINT_URL;

  const response = await fetch(`${apiBase}/master/countries`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      is_active: body.is_active ?? true,
      order_by: body.order_by ?? "asc",
      ...(body.id ? { id: body.id } : {}),
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch countries");
  }

  return response.json();
}
